import React from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useTranslation } from 'react-i18next';
import { SEOProperties } from 'store/store';

type Props = {
  seo?: SEOProperties;
  lang: string;
  path: string;
  host?: string;
  logoImage?: string;
};

export const PageMeta: React.FC<Props> = ({ seo, lang, path, host = '', logoImage }) => {
  const { t } = useTranslation();
  const title = t('title');

  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{seo?.pageTitle || title}</title>
        <meta name="description" content={seo?.metadescription || title} />
        <meta name="keywords" content={seo?.metakeywords || title} />
        <meta property="og:title" content={seo?.pageTitle || title} />
        <meta property="og:description" content={seo?.metadescription || title} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logoImage} />
        <meta property="og:url" content={`https://${host}${path}${path?.endsWith('/') ? '' : '/'}`} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=2" />
        <meta content="#444b5b" name="theme-color" />
        <link
          href="https://cdn.lemanapro.ru/lmru/image/upload/other/favicon/favicon.ico"
          rel="shortcut icon"
          type="image/x-icon"
        />
        <link href="//fonts.googleapis.com" rel="dns-prefetch" />
        <link href="https://cdn.lemanapro.ru/" crossOrigin="anonymous" rel="preconnect" />
        <link href="https://www.googletagmanager.com" crossOrigin="anonymous" rel="preconnect" />
        <link href="https://www.google-analytics.com" crossOrigin="anonymous" rel="preconnect" />
        <link href="https://fonts.gstatic.com" crossOrigin="anonymous" rel="preconnect" />
      </Helmet>
    </>
  );
};
